"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Libraries
const error_1 = __importDefault(require("../error"));
exports.default = (error, _req, res, next) => {
    // If not instanceof CustomError, just send to next error handler
    if (error instanceof error_1.default === false) {
        next(error);
    }
    // If it is a CustomError, handle the error
    // Set HTTP(s) Status code
    res.status(error.httpStatusCode);
    // Set jsonError
    const jsonError = error.apiError;
    // Add Sentry error_tracking
    if (res.sentry) {
        jsonError.error_tracking = res.sentry;
    }
    // Return formatted jsonError
    return res.json(jsonError);
};
